import { Partition } from "Models/partition";
import {
    ACTION,
    SetPartitionsAction,
    SET_PARITITIONS,
    UpdatePartitionAction,
    UPDATE_PARTITION,
} from "Redux/actionTypes";

const initialState: Partition[] = [];

export default function reduce(
    state: Partition[] = initialState,
    action: ACTION
) {
    switch (action.type) {
        case SET_PARITITIONS: {
            const {
                payload: { partitions },
            } = action as SetPartitionsAction;
            return [...partitions];
        }
        case UPDATE_PARTITION: {
            const {
                payload: { partition },
            } = action as UpdatePartitionAction;
            return state?.map((p) =>
                p.logUid === partition.logUid ? partition : p
            );
        }
        default:
            return state;
    }
}
